import React from 'react'
import { Link } from 'react-router'
import sortBy from 'lodash/sortBy'
import groupBy from 'lodash/groupBy'
import get from 'lodash/get'
import keys from 'lodash/keys'
import { prefixLink } from 'gatsby-helpers'
import { rhythm } from 'utils/typography'
import Helmet from "react-helmet"
import { config } from 'config'
import PostCategoryTag from 'components/PostCategoryTag'
import PostDateTag from 'components/PostDateTag'
import MediaQuery from 'react-responsive'

class BlogIndex extends React.Component {
  render () {
    // Sort pages.
    const sortedPages = sortBy(this.props.route.pages, 'data.date').reverse();

    let categories = keys(groupBy(sortedPages, page => get(page, 'data.category')));
    categories = categories.filter(category => { return category != "undefined" });

    // Posts are those with md extension that are not 404 pages OR have a date (meaning they're a react component post).
    const visiblePages = sortedPages.filter(page => (
      get(page, 'file.ext') === 'md' && get(page, 'data.type') === 'post' && get(page, 'data.category') === 'tech' // only tech are published
    ));
    return (
      <div>
        <Helmet
          title={config.blogTitle}
          meta={[
            {"name": "google-site-verification", "content": "-fQCqSO_uSuS5agxJQ7LE8MQZJASGD4Vbglisa253XI"},
            {"name": "description", "content": "Posts are about devops, monitoring, software development, system administration and stuff."},
            {"name": "keywords", "content": "blog, articles"},
          ]}
        />
          <h3>📰 blog posts</h3>

        <ul>
          {visiblePages.map((page) => (
              <li
                key={page.path}
                style={{
                    marginBottom: 0,
                }}
              >
                  <MediaQuery query='(min-width: 620px)'>
                      <PostDateTag date={get(page, 'data.date', page.path)} />
                      <PostCategoryTag name={get(page, 'data.category', page.path)} />&nbsp;
                      <Link style={{boxShadow: 'none'}} to={prefixLink(page.path)}>
                          {get(page, 'data.deprecated', page.path) == true && <strike>{get(page, 'data.title', page.path)}</strike>}
                          {get(page, 'data.deprecated', page.path) != true && <span>{get(page, 'data.title', page.path)}</span>}
                      </Link>
                  </MediaQuery>
                  <MediaQuery query='(max-width: 620px)'>
                      <div style={{whiteSpace: 'pre-wrap',}}>
                          <Link style={{boxShadow: 'none'}} to={prefixLink(page.path)}>
                              {get(page, 'data.deprecated', page.path) == true && <strike>{get(page, 'data.title', page.path)}</strike>}
                              {get(page, 'data.deprecated', page.path) != true && <span>{get(page, 'data.title', page.path)}</span>}
                          </Link>
                      </div>
                      <div style={{marginBottom: "5px"}}>
                          <PostCategoryTag name={get(page, 'data.category', page.path)} />&nbsp;
                          <PostDateTag date={get(page, 'data.date', page.path)} />
                      </div>
                  </MediaQuery>
              </li>
          ))}
        </ul>
          <br />
          <br />
          <a href={prefixLink("/atom.xml")}>feed</a>
          &nbsp;
          <Link title="About me" style={{boxShadow: 'none'}} to={prefixLink("/about/")}>about</Link>
      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
};

export default BlogIndex



// WEBPACK FOOTER //
// ./index.js